import Image from "@/components/Atoms/Image";
import {
	isRenderableProductImage,
	resolveProductImage,
	type ProductImageSource,
} from "@/lib/functions";
import styles from "./index.module.scss";

type ProductBottleImageProps = {
	data?: unknown;
	product?: ProductImageSource | null;
	className?: string;
};

export function ProductBottleImage({
	data,
	product,
	className,
}: ProductBottleImageProps) {
	const resolved = product ? resolveProductImage(product) : data;

	if (!isRenderableProductImage(resolved)) return null;

	return (
		<Image
			data={resolved}
			objectFit="contain"
			className={[styles.productBottle, className].filter(Boolean).join(" ")}
		/>
	);
}
